goog.provide("shadow.js.shim.module$src$svg$devices$smartphone_gen_2_svg$default");
shadow.js.shim.module$src$svg$devices$smartphone_gen_2_svg$default = shadow.js.shim.module$src$svg$devices$smartphone_gen_2_svg.default;
